var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.6,66.5c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8H23.4c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8h53.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.6,46.2c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8H23.4c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8h53.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.6,25.9c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8H23.4c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8h53.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeMenu);
export default __webpack_public_path__ + "static/media/acae_menu.a1652dd7.svg";
export { ForwardRef as ReactComponent };